const STORAGE_KEY = 'tellurvision_auth';

type AuthRecord = Record<string, unknown>;

function parseStoredAuth(): AuthRecord | null {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthRecord;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

function getInnerUser(parsed: AuthRecord | null): AuthRecord | null {
  if (!parsed) return null;
  if (parsed.user && typeof parsed.user === 'object') {
    return parsed.user as AuthRecord;
  }
  return parsed;
}

export function hasStoredOwnerAdminSession(): boolean {
  return false;
}

export function getStoredAuthToken(): string | null {
  const parsed = parseStoredAuth();
  const inner = getInnerUser(parsed);

  const candidates = [
    parsed?.token,
    parsed?.accessToken,
    parsed?.jwt,
    inner?.token,
    inner?.accessToken,
    inner?.jwt,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim().length > 0) {
      return candidate;
    }
  }

  return null;
}

export function shouldUseDevOwnerAuth(): boolean {
  return false;
}